<template>
  <div class="flex flex-col" :class="{ hidden: !isLoaded }">
    <BlockTitle class="mb-24" :subtitle :title />
    <div ref="trustpilotWidget" v-bind="configuration">
      <RevLink
        :href="configuration?.href"
        rel="noreferrer noopener nofollow"
        target="_blank"
      >
        Trustpilot
      </RevLink>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'

import type { TrustpilotWidgetApiProps } from '@backmarket/http-api/src/api-specs-content/models/trustpilot-widget'
import { RevLink } from '@ds/components/Link'

import type { BlockProps } from '../../models/content-block'
import BlockTitle from '../../shared-components/BlockTitle/BlockTitle.vue'

import { useTrustpilotCarousel } from './useTrustpilot'

export type TrustpilotWidgetBlockProps = TrustpilotWidgetApiProps & BlockProps

defineProps<TrustpilotWidgetBlockProps>()

// This event is common to every CMS block in order to hide the block containers
// on demand
defineEmits(['error', 'reset-error', 'loaded'])

const trustpilotWidget = ref<HTMLElement>()

const { configuration, isLoaded } = useTrustpilotCarousel(trustpilotWidget)
</script>
